"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const accordion_set_module_scss_1 = __importDefault(require("./accordion-set.module.scss"));
const pattern_library_components_show_more_button_1 = require("@saatva-bits/pattern-library.components.show-more-button");
const react_2 = require("react");
const accordionKinds = {
    default: 'defaultSet',
    unstyled: 'unstyledSet'
};
const AccordionSet = ({ kind = accordionKinds.default, accordionData = [], showMoreThreshold, children, className, isAccordionOpen, accordionItemName, shouldResetVisibleContent = false, onAccordionItemClick }) => {
    const [visibleContent, setVisibleContent] = (0, react_1.useState)(null);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    (0, react_2.useEffect)(() => {
        if (isAccordionOpen) {
            showMoreThreshold <= accordionData.findIndex(item => item.id === accordionItemName.split('accordion-content-')[1]) && setIsExpanded(isAccordionOpen);
            setVisibleContent(accordionItemName);
        }
        else if (shouldResetVisibleContent) { // preserves backwards compatibility but lets other components reset the visible content
            setVisibleContent(null);
        }
    }, [isAccordionOpen, accordionItemName]);
    // Only one accordion is expanded at a time
    const toggleContentHandler = (contentLabel) => {
        visibleContent === contentLabel ? setVisibleContent(null) : setVisibleContent(contentLabel);
    };
    const accordionSetClasses = (0, classnames_1.default)(accordion_set_module_scss_1.default.set, className);
    const isDefault = kind === accordionKinds.default;
    const displayShowMoreButton = Boolean(showMoreThreshold) && showMoreThreshold > 0;
    const getAccordionItems = (title, subtitle, content, index, id, otherProps) => {
        const item = children;
        const titleLabel = `accordion-title-${id ? id : index}`;
        const contentLabel = `accordion-content-${id ? id : index}`;
        const isHidableLongListItem = displayShowMoreButton && index > (showMoreThreshold - 1);
        const itemClasses = (0, classnames_1.default)({
            [accordion_set_module_scss_1.default.hidden]: isHidableLongListItem && !isExpanded,
            'u-marginBottom--md': isDefault
        }, item.props.className);
        const hasModifier = Boolean(item.props.classNameModifier);
        const defaultModifier = isDefault ? 'bgContrast1' : undefined;
        const itemProps = {
            className: itemClasses,
            visibleContent: visibleContent,
            toggleContentHandler: toggleContentHandler,
            title: title,
            subtitle: subtitle,
            singleAccordion: item.props.outsideClick,
            children: content,
            titleLabel: titleLabel,
            contentLabel: contentLabel,
            classNameModifier: hasModifier ? item.props.classNameModifier : defaultModifier,
            onAccordionItemClick: onAccordionItemClick,
            ...otherProps
        };
        return ((0, jsx_runtime_1.jsx)("li", { children: react_1.default.cloneElement(item, itemProps) }));
    };
    const listLength = accordionData.length;
    const onClickShowMoreButton = () => {
        setIsExpanded(!isExpanded);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { "data-testid": "accordionSet", className: accordionSetClasses, children: [(0, jsx_runtime_1.jsx)("ul", { "aria-label": "Accordion List", id: `accordion-set`, children: accordionData.map(({ title, subtitle, content, id, ...otherProps }, i) => (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: getAccordionItems(title, subtitle, content, i, id, otherProps) }, `accordionItem-${i}`)) }), displayShowMoreButton && listLength > showMoreThreshold &&
                (0, jsx_runtime_1.jsx)(pattern_library_components_show_more_button_1.ShowMoreButton, { isExpanded: isExpanded, controls: "accordion-set", onClick: onClickShowMoreButton })] }));
};
AccordionSet.propTypes = {
    /** Specific kinds of accordion sets available */
    kind: prop_types_1.default.oneOf(Object.values(accordionKinds)),
    /** Accordion data that will populate the accordion set. */
    accordionData: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        title: prop_types_1.default.string,
        subtitle: prop_types_1.default.string,
        content: prop_types_1.default.node,
        id: prop_types_1.default.string
    })),
    /** The option to choose the number of items to show before display the show more button. */
    showMoreThreshold: prop_types_1.default.number,
    children: prop_types_1.default.node.isRequired,
    /** Use to open the showMore button */
    isAccordionOpen: prop_types_1.default.bool,
    /** The name of an accordion item. It must contain at least a number. Ex: accordion-title-0 */
    accordionItemName: prop_types_1.default.string,
    /** A boolean that resets the visible content of the accordion set when the content is falsy */
    shouldResetVisibleContent: prop_types_1.default.bool,
    /** A function that triggers when an accordion item is open/closed */
    onAccordionItemClick: prop_types_1.default.func
};
exports.default = AccordionSet;
//# sourceMappingURL=accordion-set.js.map